import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    dailyCostReportList: (type,dateStart,dateEnd) => {
        return HTTP.get('/account/report_capital_today?type='+type+'&dateStart='+dateStart+'&dateEnd='+dateEnd, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}